import DetailsContainer from './details_container';

const JobDetails = DetailsContainer;
export default JobDetails;
